<template>
    <div class="book-meal-import">
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
            <b-card
                title="團膳菜單匯入"
            >
                <b-card-text>
                    <span> 匯入格式xlsx. </span>
                </b-card-text>

                <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    v-model="file"
                />

                <b-button
                    type="submit"
                    variant="primary"
                    @click="importSubmit"
                >
                    確定匯入
                </b-button>
            </b-card>
        </b-overlay>

    </div>
</template>
<script>
import { ref, onMounted, reactive } from '@vue/composition-api'
import { BFormFile, BCardText, BCard, BButton, BOverlay } from 'bootstrap-vue'
import utils from '@/sag-core/utils.js'
import Toast from './js/Toast.js'
import api from './js/api.js'
export default {
    components: {
        BFormFile, 
        BCardText,
        BCard,
        BButton,
        BOverlay
    },
    props: {

    },
    setup(){
        const file = ref(null)
        const toast = new Toast()
        const showLoading = ref(false)
        const importSubmit = (event)=>{

            if(file.value){
                showLoading.value = true
                const formData = new FormData()
                formData.append('file', file.value)
                formData.append('EmployeeWorkCode', utils.getUserData().workCode)
                api.Import(formData).then(()=>{
                    toast.toastSuccess(`匯入${file.value.name}成功`)
                }).catch(()=>{
                    toast.toastError(`匯入${file.value.name}失敗`)
                }).finally(()=>{
                    showLoading.value = false
                })
            }
        }

        return {
            importSubmit,
            file,
            showLoading,
        }
    },
}
</script>